import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_USER, IS_DEMO } from 'config.js';

const initialState = {
  isLogin: IS_DEMO,
  currentUser: IS_DEMO ? DEFAULT_USER : {},
  authenticated: null,
  loading: false,
  isFirstLogin: null,
  isRoutesMounted: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      const { currentUser, authenticated } = action.payload;
      state.currentUser = currentUser;
      state.authenticated = authenticated;
      state.isLogin = true;
    },
    logout(state, action) {
      state.currentUser = {};
      state.authenticated = null;
      state.isLogin = false;
      localStorage.removeItem('user');
      localStorage.removeItem('employee');
      localStorage.removeItem('app_first_login_change_pwd');
    },

    setIsFirstLogin(state, action) {
      state.isFirstLogin = action.payload;
    },

    setIsRoutesMounted(state, action) {
      state.isRoutesMounted = !state.isRoutesMounted;
    },

    setIsLogin(state, action) {
      state.isLogin = true;
    },
  },
});

export const { setCurrentUser, addToken, logout, setIsFirstLogin, setIsRoutesMounted, setIsLogin } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
